import dayjs from 'dayjs'
import formatTableJson from '@/config/tableComponentParams.js'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'deviceCode',
    label: i18n.t('Device.deviceCode')
  },
  {
    filed: 'alarm',
    label: i18n.t('Device.warningType')
  },
  {
    filed: 'alarmTime',
    type: 'time',
    label: i18n.t('Device.warningTime'),
    width: '200px'
  }
])
